/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// state
import { TStore } from '@store/index';
import { StateCreator } from 'zustand';

// datatable additionalities
import { tableSchemaBase as columns } from '../additionalities.columns';

// types
import { TColumnsSchema } from '@global-types/index';

/* -------------------------------------------------------------------------- */
/*                                  Interface                                 */
/* -------------------------------------------------------------------------- */
export interface IAdditionalitiesDatatableSlice {
	additionalitiesDatatableOptions: TColumnsSchema[];
	setAdditionalitiesDatatableOptions: (
		_additionalitiesDatatableOptions: TColumnsSchema[]
	) => void;
}

/* -------------------------------------------------------------------------- */
/*                                    Slice                                   */
/* -------------------------------------------------------------------------- */

export const partializeAdditionalitiesDatatableSlice = (
	s: any
): any => ({
	additionalitiesDatatableOptions:
		s.additionalitiesDatatableOptions,
});

const initialState = {
	additionalitiesDatatableOptions: columns.filter(
		(item) => item.defaultVisible
	),
};

export const createAdditionalitiesDatatableSlice: StateCreator<
	TStore,
	[['zustand/persist', any]],
	[],
	IAdditionalitiesDatatableSlice
> = (set) => ({
	...initialState,
	setAdditionalitiesDatatableOptions: (
		_additionalitiesDatatableOptions: TColumnsSchema[]
	) =>
		set({
			additionalitiesDatatableOptions:
				_additionalitiesDatatableOptions,
		}),
});
